export const capitalize = (word) => {
    if (word.length > 1){
        return word.charAt(0).toUpperCase() + word.substring(1, word.length).toLowerCase()
    }
}